/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useEffect } from "react";
import HeaderSection from "../../common/headerSection";
import PageHeader from "../../common/pageHeader";
import { userService as userRoleServive } from '../../../service/userService';
import { userService as plateRelatedService, userService } from '../../../service/plateServices';
import Plates from "./partials/plates";
import { columns, discardColumns } from './partials/columns';
import Discards from "./partials/discard";
import { Modal } from 'react-bootstrap';
import { TfiClose } from "react-icons/tfi";
import AlertModal from "../../../widgets/alertModal";
import CustomToast from "../../../widgets/toaster";
import { plateModels } from "./partials/PlateModels"
import { useTranslation } from 'react-i18next';
import { BatchService } from "../../../service/plateServices/discard";
import { ALLOW_CUSTOM_DATE, DEFAULT_PAGE_SIZE } from "../../../constants/constants";
import { helperFunctions } from "../../../utils/helper";
import CustomLoader from "../../../widgets/loader/loader";
import { FIELD_VALIDATIONS } from "../../../constants/fieldValidations";


const PlateInventoryV2 = () => {

  const { t } = useTranslation();

  const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
  const [tab, setTab] = useState("1");
  const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false);

  // pagination
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)

  const [plateStatus, setPlateStatus] = useState<any | null>("");
  const [plateBatches, setPlateBatches] = useState([])
  const [keyWord, setkeyWord] = useState("")
  const [fromdate, setFromDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0]
  );
  const [toDate, setToDate] = useState(currentDate)
  const [userId, setUserId] = useState<number>(0);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [showAddUserAlert, setShowAddUserAlert] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadAddModal] = useState(false)
  const [loader, setLoader] = useState(false);
  const [addPlateData, setAddPlateData] = useState({
    batchCode: "",
    serialNumber: "",
    quantity: "",
    manufactureDate: "",
    expiryDate: "",
    plateType: "",
    manufactureDetails: "",
    visualInspection: "",
    batch_grn: "",
    lotSize: "",
    mediaType: ""
  });
  interface Errors {
    batchCode?: string;
    serialNumber?: string;
    quantity?: string;
    manufactureDate?: string;
    expiryDate?: string;
    plateType?: string;
    manufactureDetails?: string;
    visualInspection?: string;
    batch_grn?: string;
    lotSize?: string;
    mediaType?: string;

  }
  interface NextSerial {
    serial_number?: string;
    next_serial_value?: string;
  }
  const [errors, setErrors] = useState<Errors>({});
  const [error, setError] = useState("")
  const [plateTypes, setPlateTypes] = useState([]);
  const [nextSerial, setNextSerial] = useState<NextSerial>({});
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [permission, setPermission] = useState<any>([]);
  const [batchNumber, setBatchNumber] = useState("")
  const [mediaType, setMediaType] = useState([]);
  const sortRemoveList=["quantity","plate_type","qa_status","status"]



  //handle table pagination 
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //api call for table plate listing 
  const getBatchList = async (sort: any, order: any) => {
    try {
      // const response = await userService.getPlateList(page, pageSize, sort, order, plateStatus, keyWord);
      const response = await BatchService.getBatchDetails(page, pageSize, sort, order, keyWord, plateStatus, fromdate, toDate, batchNumber)
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages)
            setTotalElements(response?.totalElements)
            let rowData: any = response.data.map((element: any, index: number) => {

            const plateBatchStatus = element.batch_status;
            let plateBatchType= userService.plateBatchStatus(plateBatchStatus);

              const statusName = element.qa_approved_status_name;
              const qa_status = plateRelatedService.getQAStatus(statusName);
              return {
                id: element.id,
                slno: index + 1,
                batch_number: element.batch_no,
                manufacturer_details: element.manufacturer_details,
                manufacturing_date: element.created_at,
                expiry_date: helperFunctions.formatDate(element.expiry_date),
                plate_type: element.plate_size_type_name,
                quantity: element.plate_count,
                lot_id: element.lot_id,
                status: plateBatchType,
                batch_grn: element.batch_grn,
                remaining_for_lot_assign: element.remaining_for_lot_assign,
                media_type_name: element.media_type_name,
                qa_status: qa_status
              };
            });
            setPlateDetails(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPlateDetails([])
        setTotalPages(0)
        setTotalElements(0)
      }
    } catch (error) {
      console.error('Plate response', error);
    }

  }

  //handle table filters
  const handleFilter = (key: string, value: string) => {
    if (key === "status") {
      setPlateStatus(value)
    } else if (key === "FromDate") {
      setFromDate(value)
      setToDate("")
    } else if (key === "ToDate") {
      setToDate(value)
    } else if (key === "batch_code") {
      setBatchNumber(value)
    }
    setUseEffectRequired(true)
  }

  //batch list for filter dropdown 
  const listPlateBatch = async () => {
    try {
      const response = await plateRelatedService.listPlateBatch();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {

              return {
                value: element.batch_number,
                label: element.batch_number,
              };
            });
            setPlateBatches(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }


  //handle upload button click 
  const onUploadClick = () => {
    getPlateTypeList();
    listNextPlateSerial();
    getMediaType();
    setShowAddModal(true)
  }

  //handle add modal 
  const onAddClick = () => {
    setShowBulkUploadAddModal(true)
  }

  // add exception close
  const addExceptionClose = () => {
    setShowBulkUploadAddModal(false)
    setUploadedFile(null)
    setUseEffectRequired(true)
    setError("")
    // setClearData(true)
  }

  //clear add plate modal after close 
  const addPlateClose = () => {
    setShowAddModal(false)
    setErrors({})
    setAddPlateData({
      batchCode: "",
      serialNumber: "",
      quantity: "",
      manufactureDate: "",
      expiryDate: "",
      plateType: "",
      manufactureDetails: "",
      batch_grn: "",
      visualInspection: "",
      lotSize: "",
      mediaType: ""
    });
    setNextSerial({
      serial_number: "",
      next_serial_value: ""
    })
  }

  //onchage add plate event 
  const handleAddPlateChange = (e: any) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z0-9\s]*$/;

    // setAddPlateData((prevFormData : any) => ({
    //   ...prevFormData,
    //   [name]: value,
    // }));


    const fieldsToValidate = ['batch_grn', 'batchCode', 'manufactureDetails'];

    // Clear any previous errors when user starts typing
    if (errors[name as keyof Errors]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }

    // Validate character limits for code fields (max 10 characters)
    if (( name === 'batch_grn') && value.length > FIELD_VALIDATIONS.LOCATION_NAME.MAX_LENGTH1) {
      setErrors(prev => ({
        ...prev,
        [name]: FIELD_VALIDATIONS.LOCATION_NAME.ERROR_MESSAGE1
      }));
      return;
    }
    if ((name === 'batchCode') && value.length > 15) {
      setErrors(prev => ({
        ...prev,
        [name]: "Limit exceeds 15 characters"
      }));
      return;
    }

    // Validate alphanumeric with spaces
    if (fieldsToValidate.includes(name) && !regex.test(value)) {
      setErrors(prev => ({
        ...prev,
        [name]: t('plateInventory.errors.specialChar'),
      }));
      return;
    }

    // Update the state with the new value
    setAddPlateData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));


  };

  //handle plate alert 
  const handlePlateAlert = () => {
    const errors: Errors = {};
    if (!addPlateData.batchCode) {
      errors.batchCode = t('plateInventory.errors.batchCode');
    }
    if (!addPlateData.batch_grn) {
      errors.batch_grn = t('plateInventory.errors.batchGRN');
    } 
    if (!addPlateData.plateType) {
      errors.plateType = t('plateInventory.errors.plateType');
    }
    if (!addPlateData.visualInspection) {
      errors.visualInspection = t('plateInventory.errors.visualInpection');
    }
    if (!addPlateData.quantity) {
      errors.quantity = t('plateInventory.errors.quantity');
    }
    if (!addPlateData.lotSize) {
      errors.lotSize = t('plateInventory.errors.lotSize');
    }
    if (!addPlateData.manufactureDate) {
      errors.manufactureDate = t('plateInventory.errors.manufactureDate');
    }
    if (!addPlateData.expiryDate) {
      errors.expiryDate = t('plateInventory.errors.expiryDate');
    }
    if (!addPlateData.manufactureDetails) {
      errors.manufactureDetails = t('plateInventory.errors.manufactureDetails');
    }
    // if (!addPlateData.mediaType) {
    //   errors.mediaType = t('plateInventory.errors.mediaType');
    // }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setShowAddUserAlert(true)
    setErrors({});
  }

  //api call on add plate event
  const handleAddPlateSubmit = async () => {
    setLoader(true)
    const dataToSend = {
      user_id: userId,
      batch_number: addPlateData.batchCode,
      plate_count: addPlateData.quantity,
      manufacturing_date: addPlateData.manufactureDate,
      expiry_date: addPlateData.expiryDate,
      plate_type_id: addPlateData.plateType,
      manufacturer_details: addPlateData.manufactureDetails,
      interface_name: "Plate Inventory",
      visual_inspection_flag: addPlateData.visualInspection,
      batch_grn: addPlateData.batch_grn,
      lot_size: addPlateData.lotSize,
      plate_media_type: addPlateData.mediaType
    }

    try {
      const response = await plateRelatedService.createPlateV2(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastType("success")
        setToastMessage(response.message)
        // getPlateList();
        setLoader(false)
        getBatchList(sort, order)
        addPlateClose()
        setUseEffectRequired(true)
      } else {
        setToastType("error")
        setToastMessage(response.message)
      }
      setShowAddUserAlert(false)
      setShowToast(true)
    } catch (error) {
      console.error(error);
    }finally{
      setLoader(false)
    }
  }

  //api call to get the plate types 
  const getPlateTypeList = async () => {
    try {
      const response = await plateRelatedService.listAllPlateTypes();
      if (response.status && response.statusCode === 200) {
        setPlateTypes(response.data)
      }
    } catch (error) {
      console.error('user response', error);
    }
  }

  // api to get media type
  const getMediaType = async () => {
    try {
      const response = await plateRelatedService.getMediaType();
      if (response.status && response.statusCode === 200) {
        setMediaType(response.data)
      }
    } catch (error) {
      console.error('user response', error);
    }
  }

  // handle sort
  const handleSort = (key: string, value: boolean) => {
    setSort(key)
    if (value) {
      setOrder("asc")
      getBatchList(key, "asc")
    } else {
      setOrder("desc")
      getBatchList(key, "desc")
    }

  }

  //set the serial number by default in add modal
  const listNextPlateSerial = async () => {
    try {
      const response = await plateRelatedService.listNextPlateSerial();
      if (response.status && response.statusCode === 200) {
        setNextSerial(response.data)
      }
    } catch (error) {
      console.error('user response', error);
    }
  }

  //get permission by role 
  const getPermissionByRole = async (role: number) => {
    try {
      const response = await userRoleServive.getPermissionByRole(role);
      if (response.status && response.statusCode === 200) {
        setPermission(response.data.permissions)
      }
    } catch (error) {
      console.error(error);
    }
  }

  // render all initial apis
  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id);
      getPermissionByRole(storedObject[0].role_master_id);
    }
  }, [])

  useEffect(() => {
    // getPlateList();
    getBatchList(sort, order);
    setUseEffectRequired(false)
    listPlateBatch()
  }, [useEffectRequired])


  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t('plateInventory.title')} pageDescription={t('pageDescription.plateInventory.description')} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      {/* <div className="exceptionHandlingTab">
        <button
          onClick={() => setTab("1")}
          className={tab === "1" ? "colTabBtnSel" : "colTabBtn"}
        >
          {t('plateInventory.plates')}
        </button>
        <button
          onClick={() => setTab("2")}
          className={tab === "2" ? "colTabBtnSel" : "colTabBtn"}
          >
            {t('plateInventory.discard')}
        </button>
      </div> */}
      {tab === "1" && (
        <Plates
          plateDetails={plateDetails}
          columns={columns}
          plateBatches={plateBatches}
          handleFilter={handleFilter}
          handleSort={handleSort}
          handlePageChange={handlePageChange}
          totalElements={totalElements}
          page={page}
          totalPages={totalPages}
          onUploadClick={onUploadClick}
          onAddClick={onAddClick}
          setUseEffectRequired={setUseEffectRequired}
          sortRemoveList={sortRemoveList}
        />
      )}

      {tab === "2" && (
        <Discards
          columns={discardColumns}
          plateBatches={plateBatches}
          setToastType={setToastType}
          setToastMessage={setToastMessage}
          setShowToast={setShowToast}
        />
      )}





      <Modal
        className="top-right-modal"
        centered={false}
        show={showAddModal}
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{t('plateInventory.bulk')}</p>
            <div onClick={() => addPlateClose()} className="p-2 mx-3 my-2 wrapCloseIcon">
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
          <div>
            <div className="selectWrap">
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.batch_code')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="batchCode"
                  value={addPlateData.batchCode}
                  name="batchCode"
                  type='text'
                  placeholder={t('plateInventory.batch_code')}
                  className="placeholder-style"
                  onChange={handleAddPlateChange}
                />
                {errors.batchCode && <p className="errorText">{errors.batchCode}</p>}
              </div>

              <div className="form-group my-1">
                <label>{t('plateInventory.batch_grn')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="batch_grn"
                  value={addPlateData.batch_grn}
                  name="batch_grn"
                  type='text'
                  placeholder={t('plateInventory.batch_grn')}
                  className="placeholder-style"
                  onChange={handleAddPlateChange}
                />
                {errors.batch_grn && <p className="errorText">{errors.batch_grn}</p>}

              </div>
            </div>
            <div className="selectWrap">
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.quantity')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="quantity"
                  value={addPlateData.quantity}
                  name="quantity"
                  type='number'
                  placeholder={t('plateInventory.quantity')}
                  className="placeholder-style"
                  min={1}
                  onChange={handleAddPlateChange}
                />
                {errors.quantity && <p className="errorText">{errors.quantity}</p>}
              </div>

              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.manufactureDate')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="manufactureDate"
                  value={addPlateData.manufactureDate}
                  name="manufactureDate"
                  type='date'
                  placeholder={t('plateInventory.manufactureDate')}
                  className="placeholder-style"
                  onChange={handleAddPlateChange}
                  max={new Date().toISOString().split("T")[0]}
                  onKeyDown={(e) => {
                    // Allow navigation keys (e.g., Tab, Arrow keys) and Enter to open the date picker
                    const allowedKeys = [
                      "Tab",
                      "Enter",
                      "Escape",
                    ];
                    if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}
                />
                {errors.manufactureDate && <p className="errorText">{errors.manufactureDate}</p>}
              </div>
            </div>
            <div className="selectWrap">
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.expiryDate')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="expiryDate"
                  value={addPlateData.expiryDate}
                  name="expiryDate"
                  type='date'
                  placeholder={t('plateInventory.expiryDate')}
                  onChange={handleAddPlateChange}
                  min={addPlateData.manufactureDate}
                  disabled={!addPlateData.manufactureDate}
                  //  className="custom-time-input"
                  className="placeholder-style"
                  onKeyDown={(e) => {
                    // Allow navigation keys (e.g., Tab, Arrow keys) and Enter to open the date picker
                    const allowedKeys = [
                      "Tab",
                      "Enter",
                      "Escape",
                    ];
                    if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}
                />
                {errors.expiryDate && <p className="errorText">{errors.expiryDate}</p>}
              </div>

              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.plateType')}<span style={{ color: 'red' }}>*</span></label>
                <br />
                <select
                  id="plateType"
                  value={addPlateData.plateType}
                  name="plateType"
                  onChange={handleAddPlateChange}
                >
                  <option value="">{t('common.select')}</option>
                  {plateTypes.map((obj: any, index) => (
                    <option key={index} value={obj?.id}>
                      {obj?.plate_type}
                    </option>
                  ))}
                </select>
                {errors.plateType && <p className="errorText">{errors.plateType}</p>}
              </div>
            </div>

            <div className="selectWrap">
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.manufacture_details')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="manufactureDetails"
                  value={addPlateData.manufactureDetails}
                  name="manufactureDetails"
                  type='text'
                  placeholder={t('plateInventory.manufacture_details')}
                  className="placeholder-style"
                  onChange={handleAddPlateChange}
                />
                {errors.manufactureDetails && <p className="errorText">{errors.manufactureDetails}</p>}
              </div>
              {/* </div> */}
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.visualInspection')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <select
                  id="visualInspection"
                  value={addPlateData.visualInspection}
                  name="visualInspection"
                  onChange={handleAddPlateChange}
                >
                  <option value="">{t('common.select')}</option>
                  <option value="1">{t('plateInventory.required')}</option>
                  <option value="0">{t('plateInventory.notRequired')}</option>
                </select>
                {errors.visualInspection && <p className="errorText">{errors.visualInspection}</p>}
              </div>

            </div>

            <div className="selectWrap">
              <div className="form-group my-1">
                <label htmlFor="">{t('plateInventory.lotSize')} <span style={{ color: 'red' }}>*</span></label>
                <br />
                <input
                  id="lotSize"
                  value={addPlateData.lotSize}
                  name="lotSize"
                  type='number'
                  placeholder={t('plateInventory.lotSize')}
                  className="placeholder-style"
                  min={1}
                  onChange={handleAddPlateChange}
                />
                {errors.lotSize && <p className="errorText">{errors.lotSize}</p>}
              </div>

              <div className="form-group my-1" style={{"visibility": "hidden"}}>
                <label htmlFor="">{t('plateInventory.mediaType')}<span style={{ color: 'red' }}>*</span></label>
                <br />
                <select
                  id="mediaType"
                  value={addPlateData.mediaType}
                  name="mediaType"
                  onChange={handleAddPlateChange}
                >
                  <option value="">{t('common.select')}</option>
                  {mediaType.map((obj: any, index) => (
                    <option key={index} value={obj?.id}>
                      {obj?.name}
                    </option>
                  ))}
                </select>
                {errors.mediaType && <p className="errorText">{errors.mediaType}</p>}
              </div>
            </div>

            {/* </div> */}
          </div>
          <div className="bottomArea">
            <button onClick={() => addPlateClose()} className="modalCancelBtn">
              {t('buttons.cancel')}
            </button>
            <button onClick={() => handlePlateAlert()} className="squareOrangeBtn3">{t('buttons.submit')}</button>
          </div>
          {loader && <CustomLoader />}
        </div>
      </Modal>

      {/*Modal for Bulk upload */}
      <plateModels.BulkUploadModel
        showBulkUploadModel={showBulkUploadModal}
        addExceptionClose={addExceptionClose}
        setUploadedFile={setUploadedFile}
        uploadedFile={uploadedFile}
        setError={setError}
        error={error}
      />
      {/*Alert for Bulk upload */}
      <AlertModal
        show={showAddUserAlert}
        onHide={() => setShowAddUserAlert(false)}
        title={t('common.alert')}
        message={t('plateInventory.addBulkUpload')}
        onConfirm={handleAddPlateSubmit}
      />
    </div>
  );
};
export default PlateInventoryV2;
